import { SomnologyOrganizationType } from '../../../../../common/enums/SomnologyOrganizationType';
import { SendSleepRecorderOption, SleepRecorderType } from '../../../../../common/validation/customControls/somnology';
import { CardTheme, FixedCard } from '../../molecules/card/Card';

interface IOsasCardProps {
    slaaprecorderVerzenden: SendSleepRecorderOption;
    somnologyOrganizationType: SomnologyOrganizationType;
    typeSlaaprecorder: SleepRecorderType;
}

export function OsasCard(props: Readonly<IOsasCardProps>) {
    return (
        <FixedCard
            body="Bekijk hier informatie over het slaaponderzoek."
            cardTitle="Het slaaponderzoek"
            linksText={getLinksText()}
            linksTo={
                props.somnologyOrganizationType === SomnologyOrganizationType.ksyosMedicalCenter
                    ? getLinksTo().map((link) => `/assets/documents${link}`)
                    : ['/osas/content?somnologyOrganizationType=nsi']
            }
            openInNewTab={props.somnologyOrganizationType === SomnologyOrganizationType.ksyosMedicalCenter}
            theme={CardTheme.white}
        />
    );

    function getLinksTo() {
        switch (props.typeSlaaprecorder) {
            case SleepRecorderType.nightowl:
                if (props.slaaprecorderVerzenden === SendSleepRecorderOption.sendByKsyos) {
                    return ['/NightOwl_Mini_folder.pdf', '/NightOwl_Mini_instructions.pdf'];
                } else {
                    return ['/NightOwl.pdf'];
                }
            case SleepRecorderType.nightowlReusable:
                return ['/NightOwl_Reusable_folder.pdf'];
            case SleepRecorderType.watchpat:
                return ['/WatchPat.pdf'];
            case SleepRecorderType.watchpatOne:
                return ['/WatchPat_One_folder.pdf', '/WatchPat_One_instructions.pdf'];
            case SleepRecorderType.watchpat300:
                return ['/WatchPat_300_instructions.pdf'];
        }
    }

    function getLinksText() {
        if (props.somnologyOrganizationType === SomnologyOrganizationType.ksyosMedicalCenter) {
            if (
                [SleepRecorderType.nightowl, SleepRecorderType.watchpatOne].includes(props.typeSlaaprecorder) &&
                props.slaaprecorderVerzenden === SendSleepRecorderOption.sendByKsyos
            ) {
                return ['Welkomstbrief', 'Handleiding slaaprecorder'];
            } else {
                return ['Handleiding slaaprecorder'];
            }
        } else {
            return ['Lees verder'];
        }
    }
}
